<template>
	<div class="page pageContainer">
		<div class="nav">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>基础数据</el-breadcrumb-item>
				<el-breadcrumb-item>数据统计表</el-breadcrumb-item>

			</el-breadcrumb>

		</div>

		<el-tabs v-model="activeName" type="card" style="">
			<el-tab-pane label="已缴费人数统计" name="table1"></el-tab-pane>
			<el-tab-pane label="区域招生缴费统计" name="table2"></el-tab-pane>
			<el-tab-pane label="各市投档率统计" name="table3"></el-tab-pane>
			<el-tab-pane label="联院质量表" name="table4"></el-tab-pane>
			
			

		</el-tabs>
		<div>
			<jiaofei v-if="activeName=='table1'"></jiaofei>
			<areajiaofei v-if="activeName=='table2'"></areajiaofei>
			<arealuqu  v-if="activeName=='table3'"></arealuqu>
			<stu_qulity  v-if="activeName=='table4'"></stu_qulity>
		</div>

	</div>
</template>

<script>
	import  jiaofei from './xlstable/jiaofei.vue'
	
	import  areajiaofei from './xlstable/areajiaofei.vue'
	import  arealuqu from './xlstable/arealuqu.vue'
	import  stu_qulity from './xlstable/stu_qulity_njgc.vue'
	export default {
		components: {jiaofei,areajiaofei,arealuqu,stu_qulity},
		data() {
			return {
				activeName: "table1"
			}
		},
		mounted() {

		},
		methods: {},
	}
</script>

<style>
</style>
